// Import de bibliotecas principais
import React, { useState, useRef, useEffect } from 'react'
import { headerData } from '../../../utils/wordpress/wordpressGetter'
import { useMediaQuery } from 'react-responsive'

// Import de elementos de estilização, componentes gerais e de layout
import {
	motion,
	useScroll,
	useTransform,
	easeInOut,
} from 'framer-motion/dist/framer-motion'

import { Link } from 'react-router-dom'
import { Logo } from '../../../components/main'

import './Header.scss'

const Menu = ({ variants, ...props }) => {
	const colors = ['cyan', 'green', 'grey']
	const linkVariants = {
		initial: {
			opacity: 0,
			scale: 0.2,
		},
		end: {
			opacity: 1,
			scale: 1,
			y: 2,
			transition: {
				type: 'spring',
				duration: 0.5,
			},
		},
	}

	return (
		<motion.ul className="header__menu" {...props}>
			{headerData.menu.menuItems.nodes ? (
				headerData.menu.menuItems.nodes.map((menuItem, i) => (
					<li key={menuItem.id}>
						{/* {i !== 0 ? (
							<motion.span
								variants={variants}
								className={`header__line header__line--${
									colors[(i - 1) % colors.length]
								}`}
							/>
						) : (
							<></>
						)} */}
						<motion.a
							whileHover={{ letterSpacing: '5px' }}
							variants={linkVariants}
							href={menuItem.path}
						>
							{menuItem.label}
						</motion.a>
					</li>
				))
			) : (
				<></>
			)}
		</motion.ul>
	)
}

export function Header() {
	const ref = useRef(null)
	const { scrollYProgress } = useScroll({
		target: ref,
		offset: ['0 0.1', '1 0'],
	})
	const boxY = useTransform(scrollYProgress, [0, 1], [0, -60], {
		ease: easeInOut,
	})

	useEffect(() => {
		window.onscroll = () => {
			if (scrollYProgress.current > 0.8) {
				setMobileMenu('close')
			}
		}

		setTimeout(() => {
			setLineVariation('end')
		}, 350)
	}, [])

	const [lineVariation, setLineVariation] = useState()
	const [mobileMenu, setMobileMenu] = useState('close')
	const isMobile = useMediaQuery({ query: '(max-width: 1000px)' })

	const lineVariants = {
		initial: {
			clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)',
		},
		end: {
			clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
			transition: {
				type: 'spring',
				duration: 0.4,
			},
		},
	}

	return (
		<motion.header
			ref={ref}
			initial="initial"
			animate={lineVariation}
			exit={{ opacity: 0 }}
			style={{ y: boxY }}
			variants={{
				end: {
					transition: {
						staggerChildren: 0.1,
					},
				},
			}}
			className="header wrapper"
		>
			<h1 className="header__logo">
				<a href="/">
					<Logo simple={isMobile} />
				</a>
			</h1>
			{/* <motion.span variants={lineVariants} className="header__line" /> */}
			<Menu
				variants={lineVariants}
				style={{ originX: 1, originY: 0 }}
				animate={
					isMobile
						? mobileMenu === 'open'
							? {
									opacity: 1,
									scale: 1,
									x: 0,
									y: 0,
							  }
							: {
									opacity: 0,
									scale: 0,
									x: 50,
									y: -50,
							  }
						: {}
				}
			/>
			<motion.button
				animate={mobileMenu}
				className="header__mobile mobile-only"
				onClick={() =>
					setMobileMenu(mobileMenu === 'close' ? 'open' : 'close')
				}
			>
				<motion.span
					variants={{
						close: {
							rotateZ: 0,
							backgroundColor: '#FFFFFF',
							y: 0,
						},
						open: {
							rotateZ: -135,
							backgroundColor: '#000561',
							y: 7.75,
						},
					}}
				/>
				<motion.span
					variants={{
						close: {
							scaleX: 1,
						},
						open: {
							scaleX: 0,
						},
					}}
				/>
				<motion.span
					variants={{
						close: {
							rotateZ: 0,
							y: 0,
							backgroundColor: '#FFFFFF',
						},
						open: {
							rotateZ: 135,
							y: -9.75,
							backgroundColor: '#000561',
						},
					}}
				/>
			</motion.button>
			{/* <motion.span
				variants={lineVariants}
				className="header__line header__line--purple header__line--absolute"
			/> */}
		</motion.header>
	)
}
